import styled from "styled-components"

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1280px;
  width: 100%;
`

export default Content
